import { render, staticRenderFns } from "./all-order.vue?vue&type=template&id=4cb378cc&scoped=true&"
import script from "./all-order.vue?vue&type=script&lang=js&"
export * from "./all-order.vue?vue&type=script&lang=js&"
import style0 from "./all-order.vue?vue&type=style&index=0&id=4cb378cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb378cc",
  null
  
)

export default component.exports